import { createStore } from '@atlas-frontend/sdk';
import { FC, PropsWithChildren } from 'react';

export interface OutputDataContextValue {
  loadingError?: string;
}

export const OutputDataStore = createStore<OutputDataContextValue>();
export const useOutputDataStore = OutputDataStore.useValue;

export const OutputDataContextProvider: FC<PropsWithChildren> = (props) => {
  const { children } = props;

  return (
    <OutputDataStore.Provider initialData={{}}>
      {children}
    </OutputDataStore.Provider>
  );
};
